import { client } from '../api/client.js';

export class AcceptInvitePage {
    async mount(el) {
        const hashParts = window.location.hash.split('?');
        const params = new URLSearchParams(hashParts[1] || '');
        const token = params.get('token');

        if (!token) {
            el.innerHTML = `
                <div class="auth-container">
                    <div class="auth-box">
                        <div class="auth-logo"><img class="auth-logo__mark" src="/img/heist-mark.svg" alt="" /><span class="auth-logo__word">Heist<span>.</span></span></div>
                        <h1>Invalid Invitation</h1>
                        <p class="auth-subtitle" style="margin-bottom:20px;">This invitation link is missing a token. Please check the link from your email.</p>
                        <p class="auth-switch"><a href="#login">Go to Login</a></p>
                    </div>
                </div>
            `;
            return;
        }

        if (!window.__auth__) {
            el.innerHTML = `
                <div class="auth-container">
                    <div class="auth-box">
                        <div class="auth-logo"><img class="auth-logo__mark" src="/img/heist-mark.svg" alt="" /><span class="auth-logo__word">Heist<span>.</span></span></div>
                        <h1>You've been invited!</h1>
                        <p class="auth-subtitle" style="margin-bottom:20px;">Log in or create an account to accept this workspace invitation.</p>
                        <div style="display:flex;flex-direction:column;gap:12px;">
                            <a href="#login" class="btn btn-primary" style="text-align:center;text-decoration:none;padding:14px;border-radius:10px;font-weight:600;">Log In</a>
                            <a href="#signup" class="btn btn-ghost" style="text-align:center;text-decoration:none;padding:14px;border-radius:10px;">Create Account</a>
                        </div>
                        <p style="font-size:12px;color:var(--text-muted);margin-top:16px;text-align:center;">
                            After logging in, you'll be redirected back to accept the invitation.
                        </p>
                    </div>
                </div>
            `;
            sessionStorage.setItem('heist_pending_invite', token);
            return;
        }

        el.innerHTML = `
            <div class="auth-container">
                <div class="auth-box">
                    <div class="auth-logo"><img class="auth-logo__mark" src="/img/heist-mark.svg" alt="" /><span class="auth-logo__word">Heist<span>.</span></span></div>
                    <h1>Accepting invitation...</h1>
                    <p class="auth-subtitle">Please wait while we set up your workspace access.</p>
                </div>
            </div>
        `;

        try {
            const res = await client.acceptInvite(token);
            sessionStorage.removeItem('heist_pending_invite');

            const roleLabel = res.role === 'admin' ? 'an Admin' : res.role === 'editor' ? 'an Editor' : 'a Viewer';
            el.innerHTML = `
                <div class="auth-container">
                    <div class="auth-box">
                        <div class="auth-logo"><img class="auth-logo__mark" src="/img/heist-mark.svg" alt="" /><span class="auth-logo__word">Heist<span>.</span></span></div>
                        <h1>You're in!</h1>
                        <p class="auth-subtitle" style="margin-bottom:20px;">
                            You've joined the workspace as ${roleLabel}.
                        </p>
                        <a href="#home" class="btn btn-primary" style="display:block;text-align:center;text-decoration:none;padding:14px;border-radius:10px;font-weight:600;">
                            Go to Dashboard
                        </a>
                    </div>
                </div>
            `;

            setTimeout(() => { window.location.hash = '#home'; window.location.reload(); }, 3000);
        } catch (err) {
            el.innerHTML = `
                <div class="auth-container">
                    <div class="auth-box">
                        <div class="auth-logo"><img class="auth-logo__mark" src="/img/heist-mark.svg" alt="" /><span class="auth-logo__word">Heist<span>.</span></span></div>
                        <h1>Invitation Error</h1>
                        <p class="auth-subtitle" style="margin-bottom:20px;color:var(--danger);">${err.message || 'Failed to accept invitation.'}</p>
                        <p class="auth-switch"><a href="#home">Go to Dashboard</a></p>
                    </div>
                </div>
            `;
        }
    }
    unmount() {}
}
